// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type AdminConversationsBulkMoveResponse = SlackAPIResponse & {
  bulk_action_id?: string;
  error?: string;
  needed?: string;
  not_added?: NotAdded[];
  ok: boolean;
  provided?: string;
  response_metadata?: ResponseMetadata;
};

export interface NotAdded {
  channel_id?: string;
  errors?: string[];
}

export interface ResponseMetadata {
  messages?: string[];
}
